<template>
    <client-page class="wrap wrap--sub">
        <sub-visual visual="시설·장비예약"></sub-visual>
        <rental-navigation-row />

        <section class="section">
            <v-container>
                <section class="page-section">
                    <tit-primary
                    sc="reservation"
                    tit="예약 절차 안내"
                    titTxt="전자제조지원센터는 장비 대여 및 시설 대관을 지원합니다. ">
                    </tit-primary>

                    <h4 class="tit--sm bar-txt">
                        장비 사용
                    </h4>
                    
                    <v-row class="row--large">
                        <v-col cols="12" sm="6" md="4">
                            <sub-step-card
                            icon="/images/sub/rental/intro/s1-icon1-1.svg"
                            step="1"
                            tit="장비 예약 신청"
                            sc1="- 장비 예약에서 사용을 원하는 장비를 선택"
                            sc2="- 대여 기간 및 신청폼 작성">
                            </sub-step-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <sub-step-card
                            icon="/images/sub/rental/intro/s1-icon1-2.svg"
                            step="2"
                            tit="장비 예약 승인"
                            sc1="- 관리자로 확인을 위한 절차 "
                            sc2="- 별도의 유선 및 메일로 연락이 필요할 수 있음">
                            </sub-step-card>
                        </v-col>
                        <v-col cols="12" md="4">
                            <sub-step-card
                            icon="/images/sub/rental/intro/s1-icon1-3.svg"
                            step="3"
                            tit="예약 완료"
                            sc1="- 전자제조센터 장비 사용"
                            sc2="- 사용 완료 후 사용료 지불 (관리자 협의)">
                            </sub-step-card>
                        </v-col>
                    </v-row>
                </section>
                <section class="page-section page-section--last">
                    <h4 class="tit--sm bar-txt">
                        시설 사용
                    </h4>

                    <v-row class="row--large">
                        <v-col cols="12" sm="6" md="4">
                            <sub-step-card
                            icon="/images/sub/rental/intro/s1-icon2-1.svg"
                            step="1"
                            tit="시설 예약 신청"
                            sc1="- 시설 예약에서 예약을 원하는 시설 선택"
                            sc2="- 시설 대관 목적, 대관 기간 폼 작성">
                            </sub-step-card>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <sub-step-card
                            icon="/images/sub/rental/intro/s1-icon2-2.svg"
                            step="2"
                            tit="시설 예약 승인"
                            sc1="- 관리자로 확인을 위한 절차 "
                            sc2="- 별도의 유선 및 메일로 연락이 필요할 수 있음">
                            </sub-step-card>
                        </v-col>
                        <v-col cols="12" md="4">
                            <sub-step-card
                            icon="/images/sub/rental/intro/s1-icon2-3.svg"
                            step="3"
                            tit="예약 완료"
                            sc1="- 시설 담당자로부터 사용안내 방법 등 고지"
                            sc2="- 시설 대관 완료 및 이용기간 내 이용 가능"
                            sc3="- 대관 종료 후 시설 담당자에게 고지">
                            </sub-step-card>
                        </v-col>
                    </v-row>
                </section>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import RentalNavigationRow from "@/components/client/rental/rental-navigation-row.vue";
import TitPrimary from "@/components/client/dumb/tit-primary.vue";
import SubStepCard from "@/components/client/sub/sub-step-card.vue";

export default {
    components: {
        SubVisual,
        ClientPage,
        RentalNavigationRow,
        TitPrimary,
        SubStepCard,
    },
};
</script>
